import { createFileRoute } from "@tanstack/react-router";

import AbuseReports from "./-components/AbuseReports";

export const Route = createFileRoute(
  "/_app/_dashboard/accountverification/abusereports"
)({
  component: AbuseReports,
});
